import { 
  READ_ACTION, 
  MANAGE_ACTION, 
  NPS_SURVEY,
  NPS_SURVEY_FRANCHISE,
  NPS_STRUCTURE_MENU
 } from "@/constants/resources";

export default [
  {
    title: "NPS",
    icon: "none",
    resource: NPS_SURVEY,
    action: READ_ACTION,
    children: [
      {
        title: "Meus NPS",
        icon: "UserIcon",
        route: "nps-consultant",
        resource: NPS_SURVEY,
        action: READ_ACTION,
      },
      {
        title: "NPS da estrutura",
        icon: "UsersIcon",
        route: "nps-structure",
        resource: NPS_STRUCTURE_MENU,
        action: READ_ACTION,
      },
      {
        title: "NPS dos franqueados",
        icon: "TrendingUpIcon",
        route: "nps-franchises",
        resource: NPS_SURVEY_FRANCHISE,
        action: MANAGE_ACTION,
      },
    ],
  },
];
